var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.item.loading ? _c('v-list-item', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "text-truncate "
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', [_vm.hasOpenDetailListener() ? _c('a', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.emitOpenDetail.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.item.titleReadable) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.item.titleReadable) + " ")])]), _c('v-spacer')], 1)]), !_vm.small ? _c('v-list-item-subtitle', [_vm.item.emails && _vm.item.emails.length ? _c('div', {
    staticClass: "d-flex align-items-start"
  }, [_c('v-icon', {
    staticClass: "mr-3 mt-3"
  }, [_vm._v("mdi-email")]), _c('div', _vm._l(_vm.item.emails, function (email, index) {
    return _c('refs-person-email', {
      key: 'email' + index + _vm.item.id,
      attrs: {
        "item": email,
        "small": true
      }
    });
  }), 1)], 1) : _vm._e(), _vm.item.phones && _vm.item.phones.length ? _c('div', {
    staticClass: "d-flex align-items-start"
  }, [_c('v-icon', {
    staticClass: "mr-3 mt-3"
  }, [_vm._v("mdi-phone")]), _c('div', _vm._l(_vm.item.phones, function (phone, index) {
    return _c('refs-person-phone', {
      key: 'phone' + index + _vm.item.id,
      attrs: {
        "item": phone,
        "small": true
      }
    });
  }), 1)], 1) : _vm._e(), _vm.item.phones && _vm.item.addresses.length ? _c('div', {
    staticClass: "d-flex align-items-start"
  }, [_c('v-icon', {
    staticClass: "mr-3 mt-3"
  }, [_vm._v("mdi-map-marker")]), _c('div', _vm._l(_vm.item.addresses, function (address, index) {
    return _c('refs-company-address', {
      key: 'address' + index + _vm.item.id,
      attrs: {
        "item": address,
        "small": true
      }
    });
  }), 1)], 1) : _vm._e()]) : _vm._e(), !_vm.small ? _c('v-list-item-subtitle', {
    staticClass: "text-xs"
  }, [_c('span', [_vm.loadingProject ? _c('v-skeleton-loader', {
    attrs: {
      "type": "chip"
    }
  }) : _vm.group ? _c('v-chip', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.goToPersonGroupCustomView.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("person.group")) + ": " + _vm._s(_vm.group.title) + " "), _c('v-icon', {
    staticClass: "ml-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-open-in-new")])], 1) : _vm._e()], 1)]) : _vm._e()], 1)], 1) : _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-three-line"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }